/**
 * Sticky search input for settings filter.
 * @param {object} props
 * @param {string} props.value
 * @param {function} props.onChange - fn(value)
 */
export default function SettingsSearch({ value, onChange }) {
    return (
        <input
            className="settings-search"
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder="Search settings..."
            autoComplete="off"
        />
    );
}
